'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n  background-image: ', ';\n  border-radius: 50%;\n  display: inline-block;\n  height: ', ';\n  width: ', ';\n  padding: 1px;\n\n  & div{\n    border-radius: 50%;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  & .svg{\n    height: ', ';\n    width: ', ';\n  }\n\n  &:hover div{\n    background: ', ';\n  }\n  &:hover path{\n    fill: #FFF;\n  }\n'], ['\n  background-image: ', ';\n  border-radius: 50%;\n  display: inline-block;\n  height: ', ';\n  width: ', ';\n  padding: 1px;\n\n  & div{\n    border-radius: 50%;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  & .svg{\n    height: ', ';\n    width: ', ';\n  }\n\n  &:hover div{\n    background: ', ';\n  }\n  &:hover path{\n    fill: #FFF;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sharedStyles = require('../sharedStyles');

var _reactSvg = require('react-svg');

var _reactSvg2 = _interopRequireDefault(_reactSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var getSize = function getSize(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 50 : _ref$size;
  return size + 'px';
};
var getIconSize = function getIconSize(_ref2) {
  var _ref2$iconSize = _ref2.iconSize,
      iconSize = _ref2$iconSize === undefined ? 25 : _ref2$iconSize;
  return iconSize + 'px';
};

var Icon = _styledComponents2.default.div(_templateObject, _sharedStyles.linearGradient, getSize, getSize, getIconSize, getIconSize, _sharedStyles.linearGradient);

exports.default = function (_ref3) {
  var src = _ref3.src,
      _ref3$bgColor = _ref3.bgColor,
      bgColor = _ref3$bgColor === undefined ? '#FFF' : _ref3$bgColor,
      props = _objectWithoutProperties(_ref3, ['src', 'bgColor']);

  return _react2.default.createElement(
    Icon,
    props,
    _react2.default.createElement(
      'div',
      { style: { backgroundColor: bgColor } },
      _react2.default.createElement(_reactSvg2.default, { path: src, className: 'svg' })
    )
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/lib/Icon/index.js
// module id = 114
// module chunks = 2